import React, { FC } from 'react'
import { CaretDownIcon } from '@/atoms/Icons/CaretDownIcon'
import { EyebrowMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayContext } from '../../context/GiveawayContext'

export const LearnMoreButton: FC = () => {
  const { t } = useTranslate('tickets')
  const { scrollToProducts } = useGiveawayContext()

  return (
    <button
      className="relative z-10 mx-auto mt-auto hidden cursor-pointer flex-col justify-center md:flex"
      onClick={scrollToProducts}
    >
      <EyebrowMD weight="semibold" color="white">
        <span style={{ textShadow: '1px 1px 0px rgba(0,0,0, 0.5)' }}>{t('learnMore', 'Learn More')}</span>
      </EyebrowMD>
      <div className="mx-auto mt-2 w-fit rounded-full bg-white/20 p-[10px] backdrop-blur">
        <CaretDownIcon size={20} color="white" />
      </div>
    </button>
  )
}
